import axios from "axios";
import * as FileSaver from "file-saver";
import _ from "lodash";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";
import { Assistant } from "../Assistant/Assistant";

export class BalanceSheet {
    HttpAdapter = new HttpAdapter();
    Assistant = new Assistant();
    baseUrlAssistant = `${publicSettings.aws.baseUrls.assistant}`;
    baseUrlImportBalanceSheetLambda = `${publicSettings.aws.baseUrls.importBalanceSheetLambda}`;
    bucketBalanceSheet = `${publicSettings.aws.buckets.balancesheet}`;

    async _getBase64(file, onLoadCallback) {
        return await new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    /**
     *
     * @param { {source: string, date: { year: number, month: number }, originalName: string, type: string } } fileDetails
     * @param {*} balanceSheetFile
     * @param {*} accountingId
     * @param {*} companyId
     * @returns
     */
    async saveBalanceSheetBackup(
        fileDetails,
        balanceSheetFile,
        accountingId,
        companyId
    ) {
        balanceSheetFile = await this._getBase64(balanceSheetFile);

        const response = await this.Assistant.putObjectInBucket({
            bucket: this.bucketBalanceSheet,
            key: `${accountingId}-${companyId}-${fileDetails.source}-${fileDetails.date.year}-${fileDetails.date.month}`,
            fileBase64: balanceSheetFile,
            contentType: fileDetails.type,
            metadata: {
                ...fileDetails,
                date: `${fileDetails.date.year}-${fileDetails.date.month}`,
                contentType: fileDetails.type
            }
        });

        return response;
    }

    async getListOfBalanceSheetsBackups(accountingId, companyId, source) {
        const response = await this.Assistant.listObjectsInBucket({
            bucket: this.bucketBalanceSheet,
            prefix: `${accountingId}-${companyId}`
        });

        const contents = _.get(response, "objects", []);
        const filteredKeys = contents
            .map((item) => item.key)
            .filter((k) => k.includes(source));
        return filteredKeys;
    }

    async getBalanceSheetBackup(key) {
        const responseSignedUrl = await this.Assistant.getSingleUsePreSignedUrl(
            key,
            this.bucketBalanceSheet
        );

        const preSignedUrl = responseSignedUrl.signedUrl;

        try {
            const response = await axios.get(preSignedUrl);

            FileSaver.saveAs(
                response.data,
                responseSignedUrl.metadata.originalname
            );
        } catch (error) {}
    }

    async import({
        companyId,
        accountingId,
        balanceSheet,
        date,
        system,
        ignoreError,
        userId,
        bulkImport
    } = {}) {
        if (!companyId) return null;
        if (!accountingId) return null;
        if (!balanceSheet) return null;
        try {
            const response = await this.HttpAdapter.call(
                this.baseUrlImportBalanceSheetLambda,
                {
                    companyId,
                    accountingId,
                    balanceSheet,
                    date,
                    system,
                    ignoreError,
                    userId,
                    bulkImport
                }
            );
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    }
}
